const scriptPromises: { [url: string]: Promise<Event> } = {}

// Depends on <%= csp_meta_tag %> being present in ERB
const nonceEl = document.querySelector<HTMLMetaElement>('[name="csp-nonce"]')
const nonce = nonceEl ? nonceEl.content : null

/**
 * Inserts a script tag (only once) and returns a promise that resolves once it has loaded
 * @param url The path to the script that you'd like to load
 */
export function loadScript(url: string): Promise<Event> {
  return (scriptPromises[url] =
    scriptPromises[url] ||
    new Promise((resolve, reject) => {
      const js = document.createElement('script')
      js.async = true
      // eslint-disable-next-line
      js.src = url
      js.addEventListener('load', resolve)
      js.addEventListener('error', reject)
      js.addEventListener('abort', reject)
      js.setAttribute('nonce', nonce)
      document.head.appendChild(js)
    }))
}
